package org.lennycodes.hldi.backend.db_service

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.deleteDoc
import org.lennycodes.hldi.backend.doc

suspend fun deleteAdmin(email: String) {

    val usersCollection = collection(
        FirebaseService.db,
        "users"
    )

    val adminDocument = doc(
        usersCollection,
        email
    )

    deleteDoc(adminDocument).await()

}
